import { CommonErrors, CommonRecord } from "../../../../common/CommonTypes";

export class RohrgefuehrteMedienRecord extends CommonRecord {
  [key: string]: any;   // prevents typescript error ts7053: Element implicitly has an 'any' type

  Medium?: string = ""; //*
  MediumKurzzeichen: string = "";
  Normaldruck: string = "";                       // NormaldruckBarue
  unit: string = "";                             // not a separate field on the form

  KuenftigeMengeMin: string = "";           // kunftigeAbnahmemengeMinWert
  KuenftigeMengeStundenmittel: string = "";     // kunftigeAbnahmemengeStundenmittel
  KuenftigeMengeMax: string = "";           // kunftigeAbnahmemengeMaxWert
  
  ANMStellenBezeichnung: string = ""; //*
  BisherigeMengeStundenmittel: string = "";     // bisherigeAbnahmemengeStundenmittel
  BisherigerAnschlussNWDN: string = "";         // bisherigerAnschlussNennweiteDN

  SonderfallsBeschreibung: string = "";                // BeschreibungDesSonderfalls
  // Verwendungszweck: string = "";                       // VerwendungszweckKurzbeschreibung
  Betriebsweise?: string = ""; //*
  ZykluszeitenZyklusdauer: string = ""; //*
}

export class RohrgefuehrteMedienErrors extends CommonErrors  {
  [key: string]: any;   // prevents typescript error ts7053: Element implicitly has an 'any' type

  Medium: string = "";
  MediumKurzzeichen: string = "";
  Normaldruck: string = "";                       // NormaldruckBarue

  KuenftigeMengeMin: string = "";           // kunftigeAbnahmemengeMinWert KuenftigeAbnahmemengeMinWert
  KuenftigeMengeStundenmittel: string = "";     // kunftigeAbnahmemengeStundenmittel KuenftigeAbnahmemengeStundenmittel
  KuenftigeMengeMax: string = "";           // kunftigeAbnahmemengeMaxWert KuenftigeAbnahmemengeMaxWert

  ANMStellenBezeichnung: string = "";      // AbnahmestelleMessstellenBezeichnung
  BisherigeMengeStundenmittel: string = "";     // bisherigeAbnahmemengeStundenmittel  BisherigeAbnahmemengeStundenmittel
  BisherigerAnschlussNWDN: string = "";         // bisherigerAnschlussNennweiteDN  BisherigerAnschlussNennweiteDN

  SonderfallsBeschreibung: string = "";                // BeschreibungDesSonderfalls

  // Verwendungszweck: string = "";                       // VerwendungszweckKurzbeschreibung
  Betriebsweise?: string = "";
  ZykluszeitenZyklusdauer: string = "";
}

export interface IMedium {
  Id: number,
  Medium: string,
  MediumKurzzeichen: string,
  Normaldruck: number | null,
  Aggregatszustand: string,
  unit: string,
}